import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["category", "categoryError"]
  static values = { currentCategory: String }

  connect() {
    this.initCategory()
  }

  disconnect() {
    if (this.categoryChoices) {
      this.categoryChoices.destroy()
    }
  }

  validateForm(event) {
    const hasCategory = this.categoryTarget.value !== ''

    if (!hasCategory) {
      event.preventDefault()
      this.showCategoryError()
      return false
    }

    this.hideCategoryError()
    return true
  }

  showCategoryError() {
    this.categoryErrorTarget.classList.remove("is-hidden")
  }

  hideCategoryError() {
    this.categoryErrorTarget.classList.add("is-hidden")
  }

  initCategory() {
    fetch("/categories.json")
      .then(response => response.json())
      .then(data => {
        this.setupCategory(data)
      })
  }

  setupCategory(categories) {
    this.categoryChoices = new Choices(this.categoryTarget, {
      choices: categories,
      searchFields: ['label']
    })

    // Set the current category value
    if (this.currentCategoryValue) {
      this.categoryChoices.setChoiceByValue(this.currentCategoryValue)
    }

    // Listen for category selection changes to hide error
    this.categoryTarget.addEventListener('change', () => {
      this.hideCategoryError()
    })
  }
}
